import React from 'react'
import '../styles/components/button.css';

const ResetButton = ({ onClick }) => {
  const ResetIcon = () => (
    <svg 
      width={16} 
      height={16} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      className="reset-icon"
    >
      <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
      <path d="M3 3v5h5"/>
    </svg>
  );

  return (
    <button onClick={onClick} className="reset-button">
      <ResetIcon />
    </button>
  );
};

export default ResetButton;
